<app-modal-header-common [dialogRef]="dialogRef"></app-modal-header-common>
<div class="p-4">
  <div class="header-inline mb-3" *ngIf="injectedData?.title">
    <h5>{{ injectedData.title }}</h5>
  </div>
  <mat-dialog-content>
    <p style="text-align: center;">{{ message }}</p>
  </mat-dialog-content>
</div>
<div class="message-footer d-flex justify-content-end">
  <button
    (click)="dialogRef.close()"
    mat-button
    color="primary"
    class="mx-1"
  >
    Close
  </button>
  <button
    mat-raised-button
    color="primary"
    class="templ-btn"
    (click)="onConfirmClick()"
    tabindex="1"
  >
    {{ confirmButtonText }}
  </button>
</div>
